







































import {
    ContentLoaderSize,
    SdsContentLoader,
    SdsBadge,
} from '@superbet-group/web.lib.ui-components';
import { NavigationDestination } from '@superbet-group/web.types';
import {
    defineComponent,
    PropType,
} from '@vue/composition-api';

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: true,
        },
        shouldLoadBadge: {
            type: Boolean,
            required: false,
            default: false,
        },
        badgeLabel: {
            type: String,
            required: false,
            default: null,
        },
        itemClasses: {
            type: String,
            required: false,
            default: undefined,
        },
        destination: {
            type: Object as PropType<NavigationDestination>,
            required: true,
        },
    },
    setup() {
        return {
            ContentLoaderSize,
        };
    },
    components: {
        SdsBadge,
        SdsContentLoader,
    },
});
